import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import ApexCharts from 'apexcharts';
import { ChartOptions } from '../../../../../utils/models/graphic.interface';


@Component({
  selector: 'apex-chart',
  templateUrl: './apex-chart.component.html',
  styleUrls: ['./apex-chart.scss'],
})
export class ApexChartComponent implements OnInit, OnChanges {
  chartOptions!: ChartOptions;

  chart: any;
  @Input() series = [];
  @Input() options: ChartOptions;
  @Input() update
  @Input() id: string;

  //Inicializa e cria o gŕafico
  ngOnInit(): void {
    if (this.chart) {
      this.chart.destroy();
    }
    this.createGraphic();
  }

   //Atualiza o gráfico a cada modificação no Input
  ngOnChanges(changes: SimpleChanges): void {
    this.updateApex(this.series,this.update);
  }

  updateApex(newSerie, newupdateApex) {
    if (this.chart) {
      //Atualizar dados
      if(newSerie) {
        this.chart.updateSeries(newSerie);
      }
      //Atualizar opções
      if(newupdateApex) {
        this.chart.updateOptions(newupdateApex);
      }
    }
  }

  //Criar gráfico
  createGraphic() {
    //Opções
    this.chartOptions = this.options
    setTimeout(() => {
      this.chart = new ApexCharts(
        document.querySelector(`#${this.id}`),
        this.chartOptions
      );
      this.chart.render();
    }, 100);
  }
}
